import Button from '@nebula/button';
import styled from 'styled-components';

export const SuccessPageContainer = styled.main`
  height: ${({ isWebview }) => (isWebview ? '100vh' : 'calc(100vh - 49px)')};
  min-height: 667px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  background: ${props => props.theme.color.ui.grey[10]};
  border-top: 1px solid #e2e4e7;
  width: 100%;
  gap: 24px;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    height: ${({ isWebview }) => (isWebview ? '100vh' : 'calc(100vh - 80px)')};
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    height: ${({ isWebview }) => (isWebview ? '100vh' : 'calc(100vh - 84px)')};
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: 375px;
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    width: 596px;
  }
`;
export const ConfirmationDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  background: ${props => props.theme.color.ui.grey[10]};
  align-self: stretch;
  @media ${({ theme }) => theme.media.tabletPortraitMax} {
    padding: 0px 16px;
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    gap: 32px;
  }
`;

export const SuccessIcon = styled.div.attrs(() => ({
  'aria-hidden': 'true',
}))`
  display: flex;
  width: 32px;
  height: 32px;
  margin-bottom: 8px;
`;

export const ConfirmationStatus = styled.div`
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const Heading = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: ${props => props.theme.color.ui.grey[100]};
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  line-height: 32px;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 0px;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 24px;
    line-height: 36px;
  }
`;

export const SubHeading = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
  color: ${props => props.theme.color.ui.grey[90]};
  align-self: stretch;
  margin-bottom: 0px;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 16px;
  }
`;

export const DetailsBox = styled.div`
  background: ${props => props.theme.color.brand.white};
  padding: 16px 24px;
  border-radius: 12px;
  width: 100%;
  @media ${({ theme }) => theme.media.tabletPortraitMax} {
    padding: 8px 16px;
  }
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #e2e4e7;
  &:last-child {
    border-bottom: none;
  }
  align-items: center;
`;

export const DetailLabel = styled.span`
  font-family: Roboto;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0%;
  color: ${props => props.theme.color.ui.grey[80]};
  align-self: stretch;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 18px;
    line-height: 28px;
  }
`;

export const DetailValue = styled.span`
  font-family: 'Roboto';
  font-weight: 500;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: ${props => props.theme.color.ui.grey[100]};
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 18px;
    line-height: 28px;
  }
`;

export const ActionButton = styled(Button)`
  width: 100%;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: 375px;
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    width: fit-content;
  }
`;
